import { cn } from '@/lib/cn';

/**
 * VISTAS RÁPIDAS — un solo estilo de pestañas para toda la app.
 *
 * Hoy Ventas usa píldoras e Inventario usa subrayado, y son la misma cosa. Un
 * panel donde el mismo control se ve de dos maneras obliga a aprenderlo dos
 * veces.
 *
 * Se eligió el **subrayado**: las píldoras se confunden con botones de acción,
 * y en una pantalla donde «Confirmar» y «Anular» son botones de verdad, esa
 * confusión cuesta un clic equivocado sobre dinero.
 */

export interface Vista {
  id: string;
  etiqueta: string;
  /** Contador al lado. `undefined` = no se muestra. */
  cuenta?: number;
  /** Explica qué hace el filtro. Va al tooltip. */
  ayuda?: string;
}

export function VistasGuardadas({
  vistas,
  activa,
  onCambiar,
  className,
}: {
  vistas: Vista[];
  activa: string;
  onCambiar: (id: string) => void;
  className?: string;
}) {
  return (
    <div
      className={cn('flex gap-1 overflow-x-auto border-b border-surface-border', className)}
      role="tablist"
    >
      {vistas.map((v) => {
        const esta = v.id === activa;
        return (
          <button
            key={v.id}
            role="tab"
            aria-selected={esta}
            title={v.ayuda}
            onClick={() => onCambiar(v.id)}
            className={cn(
              '-mb-px flex shrink-0 items-center gap-1.5 border-b-2 px-3 py-2 text-sm font-medium transition-colors',
              esta
                ? 'border-brand-600 text-brand-700 dark:text-brand-300'
                : 'border-transparent text-slate-500 hover:text-slate-800 dark:hover:text-slate-200',
            )}
          >
            {v.etiqueta}
            {v.cuenta != null && (
              <span
                className={cn(
                  'rounded-full px-1.5 py-0.5 text-xs tabular-nums',
                  esta
                    ? 'bg-brand-100 text-brand-800 dark:bg-brand-900/50 dark:text-brand-200'
                    : 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300',
                )}
              >
                {v.cuenta}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
